import { Link } from 'react-router-dom';
import { SeasonalSlot, useSeason, useSeasonCopy } from '../theme/seasonal';

export default function NotFound() {
  const { season } = useSeason();
  const title = useSeasonCopy('notFound.title', '');
  const body = useSeasonCopy('notFound.body', "That page isn't here.");
  const action = useSeasonCopy('notFound.action', 'Back home');

  return (
    <div className="text-center py-24 space-y-3">
      <SeasonalSlot name="not-found" />
      <p className="not-found-code font-serif text-7xl text-white">404</p>
      {season && title && <h1 className="font-serif text-4xl text-textPrimary">{title}</h1>}
      <p className="text-textSecondary">{body}</p>
      <Link to="/" className="inline-block mt-4 glass-button px-4 py-2 text-sm">
        {action}
      </Link>
    </div>
  );
}
